import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { AccountActions, ModulesSelectors } from '@serviceos-ng/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
export interface PasswordFormConfig {
    disable: boolean;
    title: string;
    edit_button_title: string;
    cancel_button_title: string;
    password: string;
    edit_form: {
        old_password_input_label: string;
        old_password_input_error: string;
        new_password_input_label: string;
        new_password_input_error: string;
        confirm_new_password_input_label: string;
        confirm_new_password_input_error: string;
        confirm_button_title: string;
    };
}

@Component({
    selector: 'serviceos-web-password-form',
    templateUrl: './password-form.component.html',
    styleUrls: ['./password-form.component.scss'],
})
export class PasswordFormComponent implements OnInit {
    public passwordForm: FormGroup;
    public passwordFormExpand = false;
    public showLoader = false;
    public formErrorMessage = '';

    @Select(ModulesSelectors.getComponentFromModule('account', 'account_settings_screen.account_details.password'))
    passwordFormConfig$!:Observable< PasswordFormConfig | null>

    constructor(
		private _fb: FormBuilder,
        private store: Store
    ) {
        this.passwordForm = this._fb.group({
            oldPassword: ['', [Validators.required, Validators.minLength(5)]],
            newPassword: ['', [Validators.required, Validators.minLength(5)]],
            confirmNewPassword: [
                '',
                [Validators.required, Validators.minLength(5)],
            ],
        });
    }

    ngOnInit(): void {}

	public async formSubmit() {
		if (this.passwordForm.valid) {
            this.showLoader = true;

            this.store
                .dispatch(
                    new AccountActions.updatePassword(
                        this.passwordForm.value.oldPassword,
                        this.passwordForm.value.newPassword,
                        this.passwordForm.value.confirmNewPassword
                    )
                )
                .pipe(
                    finalize(() => {
                        this.showLoader = false;

                        this.passwordForm = this._fb.group({
                            oldPassword: ['', [Validators.required, Validators.minLength(5)]],
                            newPassword: ['', [Validators.required, Validators.minLength(5)]],
                            confirmNewPassword: [
                                '',
                                [Validators.required, Validators.minLength(5)],
                            ],
                        });
                    })
                )
                .subscribe(
                    (res) => {
                        this.formErrorMessage = '';
                        this.passwordFormExpand = false;
                    },
                    (error) => {
                        this.formErrorMessage = error?.error[0]?.message;
                    }
                );
        } else {
            const formControlsNames: Array<string> = Object.keys(
                this.passwordForm.controls
            );

            // Manually trigger reactive form validation
            for (
                let formControlNameIndex = 0;
                formControlNameIndex < formControlsNames.length;
                formControlNameIndex++
            ) {
                const formControlName: string =
                    formControlsNames[formControlNameIndex];

                this.passwordForm.controls[formControlName].markAsTouched();
                this.passwordForm.controls[formControlName].markAsDirty();
            }
        }
    }

    /**
     * Toggle form
     */
    toggleForm() {
        this.passwordFormExpand = !this.passwordFormExpand;
        this.formErrorMessage = '';
    }

    get oldPassword() {
        return this.passwordForm.get('oldPassword');
    }

    get newPassword() {
        return this.passwordForm.get('newPassword');
    }
    get confirmNewPassword() {
        return this.passwordForm.get('confirmNewPassword');
    }
}
